var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.hasErrors)?_c('div',{staticClass:"chart-errors"},_vm._l((_vm.errors),function(value,key){return _c('div',{key:key,staticClass:"chart-errors__error",domProps:{"innerHTML":_vm._s(_vm.$options.filters.md(value))}})}),0):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }